import { useCallback } from 'react';
import { useLocalStorage } from 'react-use';

import { LOCAL_STORAGE_KEYS } from '@/constants/localStorageKeys';

interface UseAISuggestionsV2BannerDismissedResult {
  isDismissed: boolean;
  dismiss: () => void;
}

/**
 * Tracks dismissed state of the AI Suggestions V2 announcement banner for a
 * household. Dismissal is per-household and persists across all four tabs
 * the banner appears on (People, Direct Holdings, Trusts, Businesses).
 */
export function useAISuggestionsV2BannerDismissed(
  householdId: string
): UseAISuggestionsV2BannerDismissedResult {
  const [isDismissed, setIsDismissed] = useLocalStorage<boolean>(
    `${LOCAL_STORAGE_KEYS.AI_SUGGESTIONS_V2_BANNER_DISMISSED}-${householdId}`,
    false
  );

  const dismiss = useCallback(() => {
    setIsDismissed(true);
  }, [setIsDismissed]);

  return { isDismissed: !!isDismissed, dismiss };
}
